import React from 'react';
import { Text, UnorderedList, ListItem, Tooltip } from '@chakra-ui/react';
import styled from '@emotion/styled';

export interface FeatureProps {
  name: string;
  tooltip: string;
}

const Ul = styled(UnorderedList)`
  list-style: none;
`;

const Li = styled(ListItem)`
  position: relative;

  &::before {
    content: '';
    position: absolute;
    width: 10px;
    height: 10px;
    background: #7cb1ea;
    border-radius: 50%;
    left: -20px;
    top: 10px;
  }
`;

const FeatureList = ({ features = [] }: { features: FeatureProps[] }) => (
  <Ul spacing="7" fontSize="md">
    {features.map(({ name, tooltip }) => (
      <Li key={name}>
        <Tooltip
          label={tooltip}
          placement="top-start"
          background="hoverBlue"
          borderRadius="5"
          padding="2"
          closeOnClick={false}
        >
          <Text
            as="span"
            borderBottomStyle="dashed"
            borderBottomWidth="medium"
            width="fit-content"
          >
            {name}
          </Text>
        </Tooltip>
      </Li>
    ))}
  </Ul>
);

export default FeatureList;
